import { Button, Modal } from 'antd'
import React, { useEffect, useState } from 'react'
import { useLoading } from '../../context/LoadingProvider/useLoading'
import { getBingoDefinitionDetails } from '../../services/bingoDefinitions'
import { Collapse } from 'antd';

const { Panel } = Collapse;

interface BingoModalProps {
  visible: boolean
  game_id: string
  bingo_definition_id: string
  bingo_prize_id: string
  slot_definition_id: string
  close: () => void
}

function BingoModal(props: BingoModalProps) {
  const loading = useLoading()
  const [modalData, setModalData] = useState<any>({
    definition: {},
    prizes:{},
    slots:{}
  })

  useEffect(() => {
    if(props.visible && props.game_id) {
      (async () => {
        loading.addLoading()

        const params = {
          game_id: props.game_id,
          bingo_definition_id: props.bingo_definition_id,
          bingo_prize_id: props.bingo_prize_id,
          slot_definition_id: props.slot_definition_id,
        }
        
        const res = await getBingoDefinitionDetails(params)
        setModalData(res)

        loading.removeLoading()
      })()
    }
  },[props.visible])

  return (
    <div className="bingo-modal">
      <Modal 
        centered 
        open={props.visible}
        onOk={props.close} 
        onCancel={props.close} 
        width={window.innerWidth*0.8}
        footer={[
          <Button key="Close" type="primary" onClick={props.close}>
            Close
          </Button>,
        ]}
      >
        <div className="bingo-modal__preview">
          <Collapse style={{marginTop: 30}} bordered={false}>
            <Panel header="Definition" key="1">
              <pre>{JSON.stringify(modalData.definition, null, 2)}</pre>
            </Panel>
            <Panel header="Prizes" key="2">
              <pre>{JSON.stringify(modalData.prizes, null, 2)}</pre>
            </Panel>
            <Panel header="Slots" key="3">
              <pre>{JSON.stringify(modalData.slots, null, 2)}</pre>
            </Panel>
          </Collapse>
        </div>
      </Modal>
    </div>
  )
}

export default BingoModal